<template>
  <div>
    <detailing-filter
      v-if="this.filterParams.clientId"
      @filter="filterItems"
      :filters="['hotspot', 'range', 'country']"
      :default-params="filterParams"
      :loading="loading"
    ></detailing-filter>

    <hint-widget hintName="detailing" type="text" btnMore></hint-widget>

    <v-alert type="error" :value="error">{{ error }}</v-alert>
    <v-flex class="layout">
      <div class="flex xl9 lg9 md9 sm8">
        <v-data-table
          @update:pagination="updatePagination"
          item-key="phone"
          :headers="headers"
          :items="items"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :loading="loading"
          sort-icon="icon icon-arrow-top ml-2"
          next-icon="icon icon-angle-right d-flex align-center"
          prev-icon="icon icon-angle-left d-flex align-center"
          must-sort
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
            >
              <td>{{ props.item.tm_add }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.area }}</td>
              <td>{{ props.item.text }}</td>
              <td v-html="props.item.extra" class="error--text"></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <hotspot-widget
        v-if="filterParams.id"
        @openDialog="$emit('openDialog', $event)"
        :hotspot_id="filterParams.id"
      ></hotspot-widget>
    </v-flex>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";
import moment from "moment";
import DetailingFilter from "./DetailingFilter.vue";
import HotspotWidget from "../hotspot/HotspotWidget.vue";
import HintWidget from "../common/HintWidget.vue";
export default {
  name: "DetailingList",

  components: {
    DetailingFilter,
    HotspotWidget,
    HintWidget
  },

  props: {},

  data: () => ({
    error: "",
    loading: false,
    // заголовки столбцов таблицы
    headers: [
      {
        text: "Дата и время",
        sortable: true,
        value: "tm_add"
      },
      {
        text: "Телефон",
        sortable: true,
        value: "phone"
      },
      {
        text: "Страна клиента",
        sortable: true,
        value: "area"
      },
      {
        text: "Текст СМС",
        sortable: false,
        value: "text"
      },
      {
        text: "",
        sortable: false,
        value: "extra"
      }
    ],
    // данные таблицы
    items: [],
    // выбор к-ва строк на странице
    rowsPerPageItems: [10, 25, 50],
    // параметры для фильтра данных
    filterParams: {
      clientId: "",
      serviceId: "",
      range: {
        startDate: moment().subtract(1, "month"),
        endDate: new Date()
      },
      search: "",
      // страна клиента
      area: null,
      // id хотспота
      id: 0
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 25,
      sortBy: "tm_add"
    },
    // данные графика
    chartdata: null
  }),

  computed: {
    // список хотспотов
    hotspotList() {
      return this.$store.getters.hotspotList;
    }
  },

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad").then(() => {
      this.init();
    });
  },

  methods: {
    init() {
      this.filterParams.clientId = this.hotspotList[0].ess_client_id;
      this.filterParams.serviceId = this.hotspotList[0].cl_service_id;
      this.filterParams.id = this.hotspotList[0].id;
      this.getList(this.pagination);
    },

    /**
     * Получение строк из базы
     */
    getList(pagination) {
      this.error = "";
      this.loading = true;
      return new Promise((resolve, reject) => {
        RequestApi.getDetailList({
          ...this.filterParams,
          limit: pagination.rowsPerPage,
          offset:
            pagination.rowsPerPage * pagination.page - pagination.rowsPerPage,
          orderBy: [[pagination.sortBy, pagination.descending ? "DESC" : "ASC"]]
        })
          .then(data => {
            this.items = data.map(item => {
              return {
                ...item,
                area: item.area === "russia" ? "Россия" : "Зарубеж",
                extra: item.over_limit === "t" ? "&bull; Сверх лимита" : ""
              };
            });
            if (data.length) {
              this.pagination.totalItems = parseInt(data[0].full_count);
            }
            this.loading = false;
            resolve();
          })
          .catch(error => {
            this.items = [];
            this.loading = false;
            this.error = error;
            reject();
          });
      });
    },

    /**
     * Срабатывает каждый раз по событиям pagination и sort данных
     * @param pagination
     */
    updatePagination(pagination) {
      // делаем запрос, когда подгрузилось к-во всех строк,
      // не была изменена сортировка либо при смене сортировки ждем когда переключится на 1 страницу
      if (
        this.pagination.totalItems &&
        (this.pagination.sortBy === pagination.sortBy ||
          (this.pagination.sortBy !== pagination.sortBy &&
            pagination.page === 1))
      ) {
        this.loading = true;
        Common.callLastInTime(() => {
          this.getList(pagination);
        }, 500);
      }
    },

    /**
     * Фильтрация данных
     */
    filterItems(params) {
      this.filterParams = params;
      this.pagination.page = 1;
      this.getList(this.pagination);
    }
  }
};
</script>
